// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__37UMp","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__jxXZ1"};